import { useEffect, useRef } from 'react'
import { useStore } from './store'
import { AppShell } from './components/shell/AppShell'
import { Auth } from './components/auth/Auth'

function Loading() {
  return (
    <div className="flex h-full items-center justify-center bg-[var(--color-void)]">
      <div className="orb orb--ignite" data-state="thinking" style={{ width: 40, height: 40 }}>
        <div className="orb__aura" />
        <div className="orb__core">
          <div className="orb__blob orb__blob--a" />
          <div className="orb__blob orb__blob--b" />
          <div className="orb__spec" />
        </div>
        <div className="orb__comet" />
      </div>
    </div>
  )
}

export function App() {
  const init = useStore((s) => s.init)
  const ready = useStore((s) => s.ready)
  const user = useStore((s) => s.user)
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    void init()
  }, [init])

  if (!ready) return <Loading />
  if (!user) return <Auth />
  return <AppShell />
}
